import { render, staticRenderFns } from "./pc_chat.vue?vue&type=template&id=c909c144&scoped=true&"
import script from "./pc_chat.vue?vue&type=script&lang=js&"
export * from "./pc_chat.vue?vue&type=script&lang=js&"
import style0 from "./pc_chat.vue?vue&type=style&index=0&id=c909c144&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c909c144",
  null
  
)

export default component.exports